import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '@app/components/Common';
import { View } from '@/styles/reactnative';
import { useTradeModalStore } from '../../../../../../../hooks/trade/modalStore';
import { ThemeContext } from '@/theme/ThemeProvider';
import { useDemoTradingStore } from '@app/hooks/trade/demoTradingStore';
import { DemoWalletDepositModal } from '@app/components/Trade/DemoWalletDepositModal';

const AccountTransfer = ({ bgColor, color }) => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const { isDemoMode } = useDemoTradingStore();
  const [demoDepositModalOpen, setDemoDepositModalOpen] = useState(false);

  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();

  const openModal = () => {
    if (isDemoMode) {
      // 모의거래 모드: 모의지갑입금 모달 오픈
      setDemoDepositModalOpen(true);
    } else {
      // 실거래 모드: 기존 지갑전송 모달 오픈
      muatateModalStore({ ...modalStore, transferModal: true });
    }
  };

  return (
    <>
      <View style={{ flex: 1 }}>
        <CButton
          title={isDemoMode ? t('demo.walletDeposit') || '모의지갑입금' : t('transfer')}
          onClick={() => {
            openModal();
          }}
          style={{
            border: `1px solid ${theme.COLORS.PrimaryBorder}`,
            background: bgColor,
            color: color,
            height: 30,
            paddingBlock: 7,
            width: '95%',
            marginRight: 7,
            borderRadius: 2,
          }}
        />
      </View>

      {/* 모의거래 지갑 입금 모달 */}
      {isDemoMode && (
        <DemoWalletDepositModal
          open={demoDepositModalOpen}
          setOpen={setDemoDepositModalOpen}
          onSuccess={() => {
            // 입금 성공 시 추가 작업
          }}
        />
      )}
    </>
  );
};

export default AccountTransfer;
